import { createSlice } from "@reduxjs/toolkit";
import { IHolidaySlice } from "./types";
import { fetchHolidayList, upsertHoliday, deleteHoliday } from "./thunks";

const initialState: IHolidaySlice = {
  holidayList: [],
  isLoading: false,
  isError: false,
};

export const holidaySlice = createSlice({
  name: "holiday",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch
    builder.addCase(fetchHolidayList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchHolidayList.fulfilled, (state, action) => {
      state.holidayList = action.payload || [];
      state.isLoading = false;
    });
    builder.addCase(fetchHolidayList.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // Upsert
    builder.addCase(upsertHoliday.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(upsertHoliday.fulfilled, (state, action) => {
      state.isLoading = false;
      const updated = action.payload;
      if (!updated) return;

      const index = state.holidayList.findIndex((h) => h.id === updated.id);
      if (index !== -1) {
        state.holidayList[index] = updated;
      } else {
        state.holidayList.push(updated);
      }
    });
    builder.addCase(upsertHoliday.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // Delete
    builder.addCase(deleteHoliday.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteHoliday.fulfilled, (state, action) => {
      state.isLoading = false;
      const id = action.payload;
      const index = state.holidayList.findIndex((h) => h.id === id);
      if (index !== -1) {
        state.holidayList[index].isActive = false;
      }
    });
    builder.addCase(deleteHoliday.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const { reducer } = holidaySlice;
